import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "method", "action"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "a-button a-button--icon m-filter-menu__button m-filter-menu__button--basic m-filter-menu__button--clear"
}, "Apply", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "a-button a-button--primary m-filter-menu__button text--blue hidden@large",
  type: "submit"
}, "Apply", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxFormNavigation = _resolveComponent("TpxFormNavigation")!

  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass(_ctx.colourClasses),
    href: _ctx.href,
    method: _ctx.method,
    action: _ctx.url
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _renderSlot(_ctx.$slots, "navigation", {}, () => [
      (_ctx.includeNavigation)
        ? (_openBlock(), _createBlock(_component_TpxFormNavigation, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _hoisted_2,
    _hoisted_3
  ], 10, _hoisted_1))
}